import React, {useState, useEffect, useCallback} from 'react'
import { injectIntl } from 'react-intl'
import { withRouter} from 'react-router-dom'

import IdleModal from './IdleModal'


/**
 * idleWarning num of minutes before warning pops up
 * idleLogout num of minutes before we logout user.
 */
export default withRouter(injectIntl(({idleWarning = 0, idleLogout = 0, user}) => {
    const [ timer , setTimer ] = useState(0)
    const [ timerId , setTimerId ] = useState(null)
    const [ warning, setWarning] = useState(false)

    // const idleWarning = 8
    // const idleLogout = 1000

    useEffect ( () => {


        if( ! user ) {
            return
        }


        if( idleLogout !== 0 ) {
            window.addEventListener("mousemove", resetTimer);
            window.addEventListener("keypress", resetTimer);
            window.addEventListener("ontouchstart", resetTimer);
            window.addEventListener("onclick", resetTimer);

            if( ! timerId ) {
                const id = setInterval( () => setTimer(timer => timer+1), 1000 )
                setTimerId(id)
            }
        }
        
        return () => {
            if( idleLogout !== 0 ) {
                window.removeEventListener("mousemove", resetTimer);
                window.removeEventListener("keypress", resetTimer);
                window.removeEventListener("ontouchstart", resetTimer);
                window.removeEventListener("onclick", resetTimer);
                clearInterval(timerId)
            }
        }
    },[user]) // <-- warning as dep is required to make resetTimer work

    const resetTimer = () => {
        setTimer(0)
    }
  

  // watch for timeout values
  useEffect( () => {
    
    if( timer > idleLogout*60-idleWarning*60 ) {
        setWarning(true)
    }
  }, [timer])

  if( idleLogout === 0 ) {
      return null
  }

  if(  warning ) {
    return (
        <IdleModal close={() => setWarning(false)} idleWarning={idleWarning}/>
    )
  } else {
      return null
  }
}))
